var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 606,
    viewBox: "0 0 180 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7412 124.752H-225.753L-361 365.214L-225.753 605.636H44.7412L179.988 365.214L44.7412 124.752ZM-7.57064 512.675H-173.454L-256.389 365.214L-173.454 217.74H-7.57064L75.3777 365.214L-7.57064 512.675Z",
    fill: "#D9D889"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2639 0H-163.267L-274.539 197.835L-163.267 395.67H59.2639L170.536 197.835L59.2639 0Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFigure);
export default __webpack_public_path__ + "static/media/bg-figure.6df707534ab2a97e1d831aa7c167cdd9.svg";
export { ForwardRef as ReactComponent };